import "./App.css";
import React, { useState } from "react";
import LoadingBar from "react-top-loading-bar";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import NavBar from "./components/NavBar";
import Home from "./components/Home";
import About from "./components/About";
import Projects from "./components/Projects";
import Career from "./components/Career";
import Contact from "./components/Contact";
import Blog from "./components/Blog";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/Privacy";
import DeletionPolicy from "./components/Deletion";
import ScrollToTop from "./components/ScrollToTop";

const App = ()=> {
  //const apiKey = process.env.REACT_APP_NEWS_API;
  
  const [progress, setProgress] = useState(0);
  
    return (
      <div>
        <Router>
          <NavBar />
          <LoadingBar
            color="#f11946"
            height={3}
            progress={progress}
          />
          <ScrollToTop />
          
          { <Routes>
             <Route path="/" element={<Home />} />
             <Route path="/about" element={<About />} />
             <Route path="/projects" element={<Projects />} />
             <Route path="/career" element={<Career />} />
             <Route path="/contact" element={<Contact />} />
             <Route path="/blog" element={<Blog />} />
             <Route path="/privacy" element={<PrivacyPolicy />} />
             <Route path="/account_deletion" element={<DeletionPolicy />} />
            
          </Routes> }
           <Footer/>
        </Router>
       
      </div>
    );
 
}
export default App